<script setup lang="ts">
import GbButton from '@/components/GbButton.vue'
import { goalbookUrls } from '@/util/links'

defineProps<{
  message: string
}>()

const goHome = () => (window.location.href = goalbookUrls.toolkitHome)
</script>

<template>
  <div class="container flex min-h-[50vh] w-full flex-col items-center justify-center">
    <h1 class="text-display-lg font-medium">{{ message }}</h1>
    <GbButton gbTheme="bluePrimary" class="m-8" @click="goHome">Back to Toolkit Home</GbButton>
  </div>
</template>
